import styled from "@emotion/styled"
import {
  Box,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  TextField,
} from "@mui/material"
import CustomInput from "../custom-input/custom-input.component"

export const Form = styled.form`
  box-shadow: 0 21px 23px 0 rgba(0, 0, 41, 0.3);
`

export const GridContainer = styled(Grid)`
  .g-recaptcha {
    width: 100%;
  }
`

export const Question = styled.p`
  margin-bottom: 1em;
  color: #ffffff;
  font-weight: 600;
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
  line-height: ${({ theme }) => theme.typography.pxToRem(22)};
`

export const Control = styled(FormControl)`
  padding-bottom: 0.5rem;
  .MuiFormGroup-root {
    flex-direction: row;
    width: 100%;

    .MuiTypography-root {
      color: #ffffff;
    }

    .MuiButtonBase-root.Mui-checked {
      .MuiSvgIcon-root:first-child {
        fill: rgba(255, 255, 255, 0.2);
      }

      .MuiSvgIcon-root:last-child {
        fill: #f3a94c;
      }
    }

    .MuiButtonBase-root:not(.Mui-checked) {
      .MuiSvgIcon-root:first-child {
        fill: #ffffff;
      }
    }

    .MuiTextField-root {
      width: 75%;
      padding-right: 2em;

      ${({ theme }) => theme.breakpoints.down("xs")} {
        width: 65%;
      }
    }
  }
`

export const CheckboxGroup = styled(FormGroup)`
  margin-bottom: 1em;
`

export const CheckBoxGroupLabel = styled(FormLabel)`
  font-size: 1rem;
  color: ${({ theme }) => theme.palette.secondary.main};
`

export const CheckboxControl = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    font-weight: 600;
  }
`

export const CustomField = styled(CustomInput)`
  width: 100%;
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  //margin-bottom: 1.5em;
  .MuiOutlinedInput-root {
    border-radius: 5px;
    background-color: #ffffff;
    height: 40px;
    border-color: transparent;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: black;
  }

  .MuiSvgIcon-root {
    color: #848484;
    font-size: 1.8rem;
  }

  .MuiOutlinedInput-input {
    padding: 10px 14px;
  }
`

export const FormSpinner = styled(Box)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  //background-color: rgba(0,0,0,0.1);
  background-color: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

export const CustomSpinner = styled(CircularProgress)`
  color: ${({ theme }) =>
    theme.palette ? theme.palette.secondary.main : `black`};
  width: 60px !important;
  height: 60px !important;
`

export const SuccessMessage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-size: 1.5rem;
    text-align: center;
  }
`

export const ButtonWrapper = styled.div`
  max-width: 360px;
  margin: 2em auto auto auto;

  button {
    color: #ffffff;
    font-weight: 500 !important;
  }
`

export const CaptchaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`
